import type { ChatbotPrompt } from '@repo/types';

import { Icon, Typography } from '@repo/ui';

import styles from './TinyAIGreeting.module.css';

interface TinyAIGreetingProps {
  firstName: string | undefined;
  prompts: ChatbotPrompt[] | undefined;
  onPromptClick: (promptText: string, promptId: number) => void;
}

export const TinyAIGreeting = ({
  firstName,
  prompts,
  onPromptClick,
}: TinyAIGreetingProps) => {
  return (
    <div className={styles.greeting}>
      <Typography variant='heading-l' color='purple'>
        Hello there!
      </Typography>
      <Typography variant='body-m'>
        {`How can I help with ${firstName}'s results?`}
      </Typography>
      {prompts && prompts.length > 0 && (
        <div className={styles.promptChips}>
          {prompts.map(prompt => (
            <button
              key={prompt.id}
              className={styles.promptChip}
              onClick={() => onPromptClick(prompt.prompt_text, prompt.id)}
            >
              <Icon
                name='aiGradient'
                size='s'
                preserveColors
                className={styles.promptChipIcon}
              />
              <Typography variant='body-s'>{prompt.prompt_text}</Typography>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
